import groupsAthletes from '@/store/modules/groups-athletes/groups-athletes'
import groupsAthletesCreate from '@/store/modules/groups-athletes/groups-athlete-create'
import groupsAthletesDelete from '@/store/modules/groups-athletes/groups-athlete-delete'

export default {
  groupsAthletes,
  groupsAthletesCreate,
  groupsAthletesDelete
}
